import moduleDescriptions from 'root/src/shared/descriptions/modules'

import {
	bannerHeaderModuleDescriptionLenses,
} from 'root/src/client/logic/header/lenses'

const { viewBannerTabs } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewBannerTabs(
	moduleId, moduleDescriptions,
)
